"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePopulate = exports.makeSelectData = exports.useDebouncedSelector = exports.makeSelectOrdered = exports.newPopulate = exports.makePopulateDef = exports.selectFirestore = void 0;
var end2end_1 = require("@hudled/end2end");
var debounce_1 = __importDefault(require("lodash/debounce"));
var get_1 = __importDefault(require("lodash/get"));
var set_1 = __importDefault(require("lodash/set"));
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var reselect_1 = require("reselect");
var formatters_1 = require("../formatters");
var selectFirestore = function (_a) {
    var firestore = _a.firestore;
    return firestore;
};
exports.selectFirestore = selectFirestore;
var ROOT_MAPPER = {
    sourceUser: 'public_users',
    conn: 'integration_connections',
    defaultAssignee: 'public_users',
    assignee: 'public_users',
    owner: 'public_users',
    user: 'public_users',
    service: 'services',
    customer: 'recharged_customers',
    rechVendor: 'recharged_vendors',
    rechCustomer: 'recharged_customers',
};
var makePopulateDef = function (childOrChildren) {
    var isMulti = Array.isArray(childOrChildren);
    var child = isMulti ? childOrChildren[0] : childOrChildren;
    var childRootName = child.split('.').pop();
    return {
        child: "".concat(child, "Id").concat(isMulti ? 's' : ''),
        root: ROOT_MAPPER[childRootName] || (0, formatters_1.camelToSnake)((0, end2end_1.plurifier)(childRootName)),
        childAlias: isMulti ? (0, end2end_1.plurifier)(child) : child,
    };
};
exports.makePopulateDef = makePopulateDef;
var newPopulate = function (collection, childs) { return (function (firestore) { return (0, react_redux_firebase_1.populate)(firestore, collection, childs.map(function (child) { return (0, exports.makePopulateDef)(child); })); }); };
exports.newPopulate = newPopulate;
var makeSelectOrdered = function (colPath) { return (0, reselect_1.createSelector)(exports.selectFirestore, function (firestore) {
    if (!colPath.endsWith('[]')) {
        return firestore.ordered[colPath];
    }
    var colRE = new RegExp("^".concat(colPath.replace('[]', '\\[\\d+\\]'), "$"));
    return Object.entries(firestore.ordered)
        .filter(function (_a) {
        var _b = __read(_a, 1), k = _b[0];
        return k.match(colRE);
    }).map(function (ent) { return ent[1]; }).flat();
}); };
exports.makeSelectOrdered = makeSelectOrdered;
var useDebouncedSelector = function (selector) {
    var value = (0, react_redux_1.useSelector)(selector);
    var _a = __read((0, react_1.useState)(value), 2), state = _a[0], setState = _a[1];
    var setValue = (0, react_1.useCallback)((0, debounce_1.default)(function (v) { return setState(v); }, 250, { leading: true, maxWait: 5000 }), [selector]);
    (0, react_1.useEffect)(function () { return setValue(value); }, [value]);
    return state;
};
exports.useDebouncedSelector = useDebouncedSelector;
var makeSelectData = function (colPath) { return (0, reselect_1.createSelector)(exports.selectFirestore, function (firestore) {
    var dataMap = firestore.data[colPath];
    var orderedData = firestore.ordered[colPath];
    if (orderedData && (!dataMap || dataMap.id || (Object.entries(dataMap).length < orderedData.length))) {
        return Object.fromEntries(firestore.ordered[colPath].map(function (doc) { return [doc.id, doc]; }));
    }
    return dataMap;
}); };
exports.makeSelectData = makeSelectData;
var makePopulate = function (colPath, childStrings) {
    var baseSelector = (0, exports.makeSelectOrdered)(colPath);
    var childs = childStrings.map(exports.makePopulateDef);
    var populationSelectors = childs.map(function (c) { return (0, exports.makeSelectData)(c.root); });
    // const lastSelection = { items: {}, base: {}, other: Object.fromEntries(childs.map((c) => [c.root, {}])) };
    return reselect_1.createSelector.apply(void 0, __spreadArray(__spreadArray([baseSelector], __read(populationSelectors), false), [function (baseItems) {
            var otherItems = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                otherItems[_i - 1] = arguments[_i];
            }
            if (!(0, react_redux_firebase_1.isLoaded)(baseItems) || !otherItems.every(react_redux_firebase_1.isLoaded)) {
                return undefined;
            }
            if ((0, react_redux_firebase_1.isEmpty)(baseItems)) {
                return baseItems;
            }
            return baseItems.map(function (item) {
                var populatedItem = __assign({}, item);
                // ToDo: evaluate implementing per-element memoization
                // if (lastSelection.items[item.id] && item === lastSelection.items[item.id]
                //   && childs.every((c, idx) => lastSelection.other[idx] ...ToDo)) {
                // }
                childs.forEach(function (c, idx) {
                    var _a;
                    var childIdOrIds = (0, get_1.default)(populatedItem, c.child);
                    // if (isDebug) console.log('childIdOrIds', c, childIdOrIds)
                    (0, set_1.default)(populatedItem, c.childAlias, Array.isArray(childIdOrIds)
                        ? childIdOrIds
                            .map(function (childId) { var _a; return ((_a = otherItems[idx]) === null || _a === void 0 ? void 0 : _a[childId]) && __assign({ id: childId }, otherItems[idx][childId]); })
                            .filter(Boolean)
                        : ((_a = otherItems[idx]) === null || _a === void 0 ? void 0 : _a[childIdOrIds]) && __assign({ id: childIdOrIds }, otherItems[idx][childIdOrIds]));
                });
                return populatedItem;
            });
        }], false));
};
exports.makePopulate = makePopulate;
